import React, { Fragment, Component } from 'react';
import { translate } from '../Services/translation';
class FacetedSearchGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      showLessItemCount: 5,
      isFirstCall:true
    };
    this.toggleShowMore = this.toggleShowMore.bind(this);
  }
  componentDidMount() {
    const visible =  this.refs.list !== undefined && this.refs.list.getBoundingClientRect().height !== 0;
    const tooMuchItem = this.props.group.options.filter(o => o.quantity > 0).length > this.state.showLessItemCount;
     visible && tooMuchItem && this.toggleShowMore();  
  }

  componentDidUpdate(prevProps){
    if(prevProps!=this.props)
    {      
      if(this.state.isFirstCall)
      {
        this.setState({collapsed:false,isFirstCall:false})
      }
      const length= this.props.group.options.filter(o => o.quantity > 0).length;    
      if(this.refs.list!=undefined)
      {
        if(length<5)
        {
          this.refs.list.style.height = `${50+(32*length)}px`
        }else{
          this.refs.list.style.height = `${185}px`;    
          if(this.state.isFirstCall==false)
          {
            this.setState({collapsed:true});
          }
        }
      }      
    }
  }

  toggleShowMore() {
    const topPos = this.refs.list.getBoundingClientRect().top;
    const lessBottomPos = this.refs.showLess.getBoundingClientRect().bottom;
    const moreBottomPos = this.refs.showMore.getBoundingClientRect().bottom;
    const setHeight = () => {    
      this.refs.list.style.height = `${(this.state.collapsed ? lessBottomPos : moreBottomPos) - topPos}px`
    };
    const toggleCollapse = () => {
      this.setState(
        (prevState, props) => ({
          collapsed: !prevState.collapsed,
        }),
        () => {
          setHeight();
        }
      );
    };
    if (!this.refs.list.style.height) {
      setHeight();
      setTimeout(() => {
        toggleCollapse();
      }, 0);
    } else {
      toggleCollapse();
    }
  }
  render() {
    const { group, searchFacetChange } = this.props;
    return (
      <Fragment>
        {group.options && group.options.filter(o => o.quantity > 0).length > 0 &&
        <Fragment>
          <ul className='faceted-search__group' ref='list'>
            <div className='faceted-search__group-header'>
              {group.label}
            </div>
            {group.options &&
              group.options.map((item, itemIndex, array) => (
                !isNaN(item.quantity) && item.quantity > 0 && <li key={`${item.label}-${itemIndex}`} className='faceted-search__item' role='option' ref={itemIndex === this.state.showLessItemCount - 1 ? 'showLess' : itemIndex === array.length - 1 ? 'showMore' : null}>
                  <FacetedFilterCheckbox item={item} group={group} searchFacetChange={searchFacetChange} />
                </li>
              ))}
          </ul>
          {group.options.filter(o => o.quantity > 0).length > this.state.showLessItemCount && (
            <span className='faceted-search__show-more' onClick={this.toggleShowMore}>
              {`${this.state.collapsed ? translate('filter.showmore') : translate('filter.showless')}`}
            </span>
          )}
        </Fragment>
        }
      </Fragment>
    );
  }
}
const FacetedSearch = ({ facetFilters, query, searchFacetChange, navigationTheme, clearFilterApplied, loading }) =>
  navigationTheme !== 'category' && (
      <Fragment>        
          <ul className='faceted-search'>{facetFilters && facetFilters.map((group, groupIndex, array) => <FacetedSearchGroup key={`${group.label}-${groupIndex}`} group={group} searchFacetChange={searchFacetChange} />)}</ul>
        </Fragment>
  );
const FacetedFilterCheckbox = ({ item, group, searchFacetChange }) => (
  <label className='faceted-filter'>
    <input className='faceted-filter__input' type='checkbox' onChange={(event) => searchFacetChange(group, item)} checked={group.selectedOptions != null && group.selectedOptions.includes(item.id)} />
    <span className='faceted-filter__label'>
     {item.label}
     {!isNaN(item.quantity) && item.quantity > 0 && <span className='faceted-filter__quantity'>&nbsp;({item.quantity})</span>}
    </span>
  </label>
);
export default FacetedSearch;